module.exports = __webpack_public_path__ + "static/media/blog-details.bdeb8a47.jpg";